import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ItemsList, TeamCard } from "@parkschannel/ui";
import { NextAvatar } from "../../../NextAvatar";
import classNames from "classnames";
export const TeamCardList = (param)=>{
    let { members  } = param;
    return /*#__PURE__*/ _jsx(ItemsList, {
        className: "grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-10 ",
        items: members,
        renderItem: (member)=>/*#__PURE__*/ _jsx(TeamCard, {
                name: member.name,
                position: member.shortDescription,
                text: member.description,
                avatar: /*#__PURE__*/ _jsx(NextAvatar, {
                    src: member.avatar_key,
                    size: "xl",
                    className: classNames("md:w-[136px] md:h-[136px] lg:w-[168px] lg:h-[168px] drop-shadow-xl")
                })
            })
    });
};
